export class AwsNativeStandardIntervalConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "intervalHours",
            "baseName": "intervalHours",
            "type": "AwsNativeStandardIntervalConfigIntervalHoursEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativeStandardIntervalConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var AwsNativeStandardIntervalConfigIntervalHoursEnum;
(function (AwsNativeStandardIntervalConfigIntervalHoursEnum) {
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_1"] = 1] = "NUMBER_1";
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_2"] = 2] = "NUMBER_2";
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_4"] = 4] = "NUMBER_4";
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_6"] = 6] = "NUMBER_6";
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_8"] = 8] = "NUMBER_8";
    AwsNativeStandardIntervalConfigIntervalHoursEnum[AwsNativeStandardIntervalConfigIntervalHoursEnum["NUMBER_12"] = 12] = "NUMBER_12";
})(AwsNativeStandardIntervalConfigIntervalHoursEnum || (AwsNativeStandardIntervalConfigIntervalHoursEnum = {}));
